import { SharedForm } from '@components';
import { useStore } from '@stores';
import { Form, FormInstance, Input } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

const { TextArea } = Input;

interface IProps {
  form: FormInstance<any>;
  handleSubmit: (values: any) => Promise<void>;
}

const OrderNoteForm: React.FC<IProps> = ({ form, handleSubmit }) => {
  const { orderStore } = useStore();
  const { orderNoteLoading } = orderStore;

  return (
    <SharedForm
      hideCancel
      form={form}
      submitTitle="Submit"
      onFinish={handleSubmit}
      loading={orderNoteLoading}
      submitDisabled={orderNoteLoading}
    >
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="orderId" hidden>
        <Input />
      </Form.Item>
      <Form.Item
        name="description"
        label="Add new note here"
        rules={[{ message: 'Please enter new note', required: true }]}
      >
        <TextArea rows={4} placeholder="Enter your note here" />
      </Form.Item>
    </SharedForm>
  );
};

export default observer(OrderNoteForm);
